import React, { useState } from 'react';

/**
 * CopyFreePNG - компонент для копирования PNG в буфер обмена
 * @param {Object} props - параметры компонента
 * @param {string} props.slug - слаг иконки
 * @param {string} props.collection - коллекция иконки
 * @param {string} props.url - URL изображения для копирования (опционально)
 * @param {Function} props.onBeforeAction - колбэк перед копированием
 */
const CopyFreePNG = ({ 
  slug, 
  collection, 
  url,
  onBeforeAction
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleCopy = async () => {
    // Вызов колбэка перед копированием, если он предоставлен
    if (typeof onBeforeAction === 'function') {
      const shouldContinue = onBeforeAction();
      if (shouldContinue === false) {
        return;
      }
    }

    try {
      // Определяем URL для копирования
      let imageUrl = url;
      
      if (!imageUrl) {
        // Формируем URL, если он не предоставлен
        if (collection === 'basic3d') {
          imageUrl = `https://icons-pbl.davooda.com/basic3d-icons/png-512px/${slug}.png`;
        } else {
          console.error('Unknown collection for CopyFreePNG');
          setIsError(true);
          setTimeout(() => setIsError(false), 2000);
          return;
        }
      }

      // Копирование изображения в буфер обмена
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      
      // Создаем объект для буфера обмена
      const data = [new ClipboardItem({ [blob.type]: blob })];
      await navigator.clipboard.write(data);

      // Показываем уведомление об успешном копировании
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error('Error copying PNG:', error);
      setIsError(true);
      setTimeout(() => setIsError(false), 2000);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className="inline-flex items-center text-black cursor-pointer"
    >
      {isError ? (
        <span className="text-red-500">Failed to copy</span>
      ) : isCopied ? (
        <span>Copied!</span>
      ) : (
        <span>Copy PNG</span>
      )}
    </button>
  );
};

export default CopyFreePNG;